<template>
  <section class="views">
    <!-- header -->
    <headers select="4"></headers>

    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require(`@/assets/image/hodgepodge/pcbanner_${this.$i18n.locale}.jpg`)"
      />
    </div>

    <div class="content">

      <div class="viewsList">
        <ul class="animate__animated animate__bounceInLeft" v-if="select === 0">
          <li
            v-for="(item, index) in pdfList"
            :key="index"
            @click="pdfBut(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
   
  <script>
import headers from '@/components/header/pc_header'
export default {
  name: 'constitution',
  data() {
    return {
      anshow: true,
      pdf: {
        constitution_zh: [
          // 中文
          {
            name: '比赛章程',
            url: 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/591fa766026f2ed472115876246887f7.pdf'
          },
          {
            name: '决赛章程',
            url: 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/a233036882cc10fa22eb9a6b937ae4ad.pdf'
          },
        ],
        constitution_id: [
          // 印尼
          {
            name: '比赛章程',
            url: 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/8490e9829b4f0f0113c7cbc25a789b10.pdf'
          },
          {
            name: '决赛章程',
            url: 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/4d02469bd98961676f6dcad232c41ad6.pdf'
          },
        ],
      },
      pdfList: [],
      select: 0
    }
  },
  computed: {},
  components: {
    headers
  },
  created() {
    if(this.$i18n.locale === 'zh_CN') {
      this.pdfList = this.pdf[`constitution_zh`]
    } else {
      this.pdfList = this.pdf[`constitution_id`]
    }
  },
  mounted() {},
  methods: {
    getPdf(e) {
      this.$axios({
        url: e.url,
        method: 'get',
        responseType: 'blob'
      })
        .then((response) => {
          this.$toast.clear()
          this.$toast.success('开始下载')
          // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob) // 创建下载链接
          downloadElement.href = href
          downloadElement.download = e.name // 文件名
          document.body.appendChild(downloadElement)
          downloadElement.click() // 下载
          document.body.removeChild(downloadElement) // 下载完成后移除元素
          window.URL.revokeObjectURL(href) // 释放占用的内存空间
        })
        .catch((error) => {
          this.$toast.clear()
          console.error(error) // 处理异常情况
        })
    },
    pdfBut(e) {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '誦材暫未開放下載',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })

      if (e.url) {
        // this.getPdf(e);
        window.open(e.url, '_blank')
      } else {
        // this.$dialog
        //   .alert({
        //     title: '提示',
        //     message: '暫未開放下載',
        //     confirmButtonText: '確認'
        //   })
        //   .then(() => {
        //     // on close
        //   })
      }
    },
  }
}
</script>
  
  <style lang="scss" scoped>
.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 19px;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    margin: auto;

    .viewsBoxTab {
      width: 100%;
      position: relative;
      background: #d34a00;

      .viewsTab {
        width: 100%;
        max-width: 1024px;
        margin: auto;
        box-sizing: border-box;
        display: flex;

        ul {
          width: 100%;
          height: 64px;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          li {
            width: 190px;
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            line-height: 20px;
            flex: 0 0 auto;
            background: #d34a00;
            cursor: pointer;

            div {
              width: 100%;
            }

            div:nth-child(1) {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }

            div:nth-child(2) {
              font-size: 11px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }
          }

          .select {
            font-size: 16px;
            font-weight: 600;
            color: #903300;
            padding: 8px 0;
            background: url('~@/assets/image/hodgepodge/tabbuttom.png')
              no-repeat;
            background-size: 100% 100%;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #903300;
            }
          }
        }
      }
    }

    .viewsList {
      width: 100%;
      max-width: 1024px;
      margin: 64px auto 50px auto;
      padding: 0.32rem;
      box-sizing: border-box;

      ul {
        width: 100%;

        li {
          width: 640px;
          height: 124px;
          margin: auto;
          background: #fff8de;
          box-shadow: 0px 0px 4px 0px rgba(126, 56, 0, 0.26);
          border: 4px solid #fff0e1;
          border-radius: 16px;
          margin-bottom: 32px;
          font-size: 24px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ff782f;
          line-height: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>